module.exports = __webpack_public_path__ + "static/media/IKMS07.274fec91.jpg";